/**
 * Tax & Government Settlements — /sframe-204-s3/:estateId
 */

import { useParams } from 'react-router-dom';
import SettlementChecklistShell from '../../settlement/SettlementChecklistShell';

const FRAME_ID = 'sframe-204-s3';

const ITEMS = [
  {
    id: 'tg-1',
    title: 'Submit Federal Estate Tax',
    description: 'File Form 706 if required and submit payment. Obtain IRS confirmation of receipt.',
  },
  {
    id: 'tg-2',
    title: 'Pay State & Local Property Taxes',
    description: 'Settle any outstanding property tax balances and confirm no liens remain.',
  },
  {
    id: 'tg-3',
    title: 'Obtain Government Tax Clearance',
    description:
      'Request state tax clearance letter (required in many states before final distribution).',
  },
];

export default function PayDebts_TaxGov() {
  const { estateId } = useParams<{ estateId: string }>();

  if (!estateId) return <div className="p-8 text-stone-600 text-sm">Select an estate.</div>;

  return (
    <SettlementChecklistShell
      estateId={estateId}
      frameId={FRAME_ID}
      title="Tax & Government Settlements"
      backTo={`/sframe-204/${estateId}`}
      backLabel="← Pay Validated Debts"
      items={ITEMS}
      payDebtsHubKey="s3"
    />
  );
}
